// extracted by mini-css-extract-plugin
export default {"container":"dk-z","freeShip":"ek-z","privacy":"fk-z"};